<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs6>
        <h1 class="headline mt-2">Ticket List</h1>
      </v-flex>
      <v-flex xs6 class="text-xs-right">
        <span>
          <v-btn @click="exportData" outline color="grey" class="ma-0 mb-1">
            <i class="fas fa-file-export mr-1"></i>
            {{ $t('export') }}
          </v-btn>
        </span>
        <template v-if="$store.state.privilege && $store.state.privilege.create_ticket">
          <add-ticket @addTicket="onAddTicket" :loading="loading"></add-ticket>
        </template>

        <v-btn color="primary" depressed @click="showSearch = true" :loading="loading">
          <v-icon class="mr-1">search</v-icon>Search
        </v-btn>
        <v-btn :loading="loading" @click="onSearch" color="primary" icon>
          <i class="fas fa-sync-alt"></i>
        </v-btn>
        <v-dialog v-model="showSearch" persistent max-width="600" scrollable>
          <v-card>
            <div class="text-xs-right">
              <v-btn small flat fab @click="showSearch = false" :loading="loading">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <v-divider></v-divider>
            <v-card-text max-height="600">
              <div class="caption">Channel</div>
              <v-radio-group v-model="filter.channel" d-inline row>
                <v-radio class="mb-2" :value="null" color="primary" label="All"></v-radio>
                <v-radio
                  class="mb-2"
                  :value="'facebook'"
                  color="primary"
                  label="Facebook"
                ></v-radio>
                <v-radio class="mb-2" :value="'line'" color="primary" label="Line"></v-radio>
                <v-radio class="mb-2" :value="'phone'" color="primary" label="phone"></v-radio>
                <v-radio class="mb-2" :value="'email'" color="primary" label="email"></v-radio>
                <v-radio class="mb-2" :value="'website'" color="primary" label="website"></v-radio>
                <v-radio class="mb-2" :value="'others'" color="primary" label="others"></v-radio>
              </v-radio-group>

              <div class="caption">Status</div>
              <v-radio-group v-model="filter.status" d-inline row>
                <v-radio class="mb-2" :value="null" color="primary" label="All"></v-radio>
                <v-radio class="mb-2" :value="'pending'" color="primary" label="Pending"></v-radio>
                <v-radio
                  class="mb-2"
                  :value="'answered'"
                  color="primary"
                  label="Answered"
                ></v-radio>
                <v-radio class="mb-2" :value="'closed'" color="primary" label="Closed"></v-radio>
                <v-radio
                  class="mb-2"
                  :value="'cancelled'"
                  color="primary"
                  label="Cancelled"
                ></v-radio>
                <v-radio
                  class="mb-2"
                  :value="'cancelled by customer'"
                  color="primary"
                  label="Cancelled by customer"
                ></v-radio>
              </v-radio-group>

              <v-layout wrap>
                <v-flex xs12 sm6 class="px-1">
                  <div class="caption">Phone number</div>
                  <div class="form-control">
                    <input v-model="filter.contact_phone" type="number" />
                  </div>
                </v-flex>
                <v-flex sm6 xs12></v-flex>
                <v-flex xs12 sm6 class="px-1">
                  <div class="caption">Group</div>
                  <multiselect
                    class="mb-3"
                    v-model="filter.group"
                    :options="agentGroupOptions"
                    label="groupname"
                    selectLabel
                    selectedLabel
                    :allow-empty="false"
                    :searchable="false"
                    deselect-label
                    @input="onChangeGroup"
                    track-by="groupname"
                  ></multiselect>
                </v-flex>
                <template v-if="filter.group && filter.group.id != null">
                  <v-flex xs12 sm6 class="px-1">
                    <div class="caption">Sub Group</div>
                    <multiselect
                      class="mb-3"
                      v-model="filter.subgroup"
                      :key="`sub_${filter.group.id}`"
                      :options="agentSubGroupOptions"
                      label="subgroupname"
                      selectLabel
                      selectedLabel
                      :allow-empty="false"
                      :searchable="false"
                      deselect-label
                      @input="onChangeSubGroup"
                      track-by="subgroupname"
                    ></multiselect>
                  </v-flex>
                  <v-flex class="px-1">
                    <div xs12 class="caption">Admin</div>
                    <multiselect
                      class="mb-3"
                      v-model="filter.admin"
                      :key="`admin_${filter.group.id}`"
                      :options="agentAdminOptions"
                      label="name"
                      selectLabel
                      selectedLabel
                      :allow-empty="false"
                      :searchable="false"
                      deselect-label
                      track-by="name"
                    ></multiselect>
                  </v-flex>
                </template>
              </v-layout>

              <div class="px-1">
                <div class="caption">Priority</div>
                <multiselect
                  class="mb-3"
                  v-model="filter.priority"
                  :key="`priority`"
                  :options="priorityOptions"
                  label="text"
                  selectLabel
                  selectedLabel
                  :allow-empty="false"
                  :searchable="false"
                  deselect-label
                  track-by="text"
                ></multiselect>
              </div>

              <div class="px-1">
                <div class="caption">Tags</div>
                <v-combobox
                  v-model="tags"
                  :filter="tagsfilter"
                  :hide-no-data="!search"
                  :items="items"
                  :search-input.sync="search"
                  hide-selected
                  label="Search for an option"
                  multiple
                  small-chips
                  solo
                >
                  <template v-slot:no-data>
                    <v-list-tile>
                      <span class="subheading">Create</span>
                      <v-chip :color="`primary lighten-3`" label small>{{ search }}</v-chip>
                    </v-list-tile>
                  </template>
                  <template v-slot:selection="{ item, parent, selected }">
                    <v-chip
                      v-if="item === Object(item)"
                      :color="`primary lighten-3`"
                      :selected="selected"
                      label
                      small
                    >
                      <span class="pr-2">{{ item.text }}</span>
                      <v-icon small @click="parent.selectItem(item)">close</v-icon>
                    </v-chip>
                  </template>
                  <template v-slot:item="{ index, item }">
                    <v-list-tile-content>
                      <v-text-field
                        v-if="tagediting === item"
                        v-model="tagediting.text"
                        autofocus
                        flat
                        background-color="transparent"
                        hide-details
                        solo
                        @keyup.enter="tagsedit(index, item)"
                      ></v-text-field>
                      <v-chip v-else :color="`primary lighten-3`" dark label small>{{
                        item.text
                      }}</v-chip>
                    </v-list-tile-content>
                    <v-spacer></v-spacer>
                    <v-list-tile-action @click.stop>
                      <v-btn icon @click.stop.prevent="tagsedit(index, item)">
                        <v-icon>{{ tagediting !== item ? 'edit' : 'check' }}</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </template>
                </v-combobox>
              </div>
              <v-divider class="my-2" />

              <div class="font-wight-bold mb-2">Ticket Date</div>

              <date-range-picker v-model="selectedDate"></date-range-picker>

              <v-divider class="my-2" />

              <div class="font-wight-bold mb-2">Due Date</div>

              <date-range-picker v-model="selectedDueDate"></date-range-picker>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn block color="grey" outline @click="clearSearch" :loading="loading">
                {{ $t('Clear') }}
              </v-btn>
              <v-btn block color="primary" depressed @click="onSearch" :loading="loading">
                {{ $t('Search') }}
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <div class="mb-2">
      <v-chip dark color="blue" v-for="(item, k) in showFilter" :key="k">{{ item }}</v-chip>
    </div>
    <template v-if="showTable">
      <v-data-table
        :headers="headers"
        :pagination.sync="pagination"
        :items="filterTickets"
        class="elevation-1"
        hide-actions
        :loading="loading"
        :key="timestamp"
      >
        <!-- Name,Email,Phone,Channel , Note, Status, Assign to, Group ,Subgroup -->
        <template v-slot:items="props">
          <tr
            @click="$refs['editticket_' + props.item.id].openModal()"
            class="lighten-5"
            :class="{
              grey: props.item.status == 'closed',
              orange: props.item.status == 'pending',
              red: props.item.status == 'cancelled',
              purple: props.item.status == 'cancelled by customer',
            }"
          >
            <td>
              <v-btn
                @click.stop="goToLivechat(props.item, props.item.app)"
                icon
                outline
                color="primary"
              >
                <i class="fas fa-comments"></i>
              </v-btn>
              <edit-ticket
                :ref="`editticket_${props.item.id}`"
                v-model="props.item"
                :key="props.item.id"
                @editTicket="onEditTicket"
                :loading="loading"
              ></edit-ticket>
            </td>
            <td>
              <v-chip color="yellow" small dark v-if="props.item.priority == 'low'">{{
                props.item.priority
              }}</v-chip>
              <v-chip color="orange" small dark v-else-if="props.item.priority == 'medium'">{{
                props.item.priority
              }}</v-chip>
              <v-chip color="red" small dark v-else>{{ props.item.priority }}</v-chip>
            </td>
            <td>{{ props.item.first_name }} {{ props.item.last_name }}</td>
            <td>{{ props.item.contact_email }}</td>
            <td>{{ props.item.contact_phone }}</td>
            <td v-if="props.item.app == 'facebook'">
              <i style="color: rgb(59, 89, 152)" class="fab fa-facebook-square"></i>
            </td>
            <td v-else-if="props.item.app == 'line'">
              <i style="color: rgb(0, 195, 0)" class="fab fa-line"></i>
            </td>
            <td v-else>
              <i style="color: grey" class="fas fa-envelope"></i>
            </td>
            <td style="min-width: 300px">{{ props.item.subject }}</td>
            <td style="min-width: 300px">{{ props.item.details }}</td>
            <td>
              <v-chip
                v-if="props.item.status == 'pending'"
                :color="'warning'"
                small
                disabled
                class="white--text"
                >{{ props.item.status }}</v-chip
              >
              <v-chip
                v-else-if="props.item.status == 'closed'"
                :color="'grey'"
                small
                disabled
                class="white--text"
                >{{ props.item.status }}</v-chip
              >
              <v-chip
                v-else-if="props.item.status == 'cancelled'"
                :color="'error'"
                small
                disabled
                class="white--text"
                >{{ props.item.status }}</v-chip
              >
              <v-chip
                v-else-if="props.item.status == 'cancelled by customer'"
                :color="'#fd87ee'"
                small
                disabled
                class="white--text"
                >cancelled by customer</v-chip
              >
              <v-chip
                v-else-if="props.item.status == 'answered'"
                :color="'info'"
                small
                disabled
                class="white--text"
                >{{ props.item.status }}</v-chip
              >
              <v-chip
                v-else-if="props.item.status == 'open'"
                :color="'green'"
                small
                disabled
                class="white--text"
                >{{ props.item.status }}</v-chip
              >
              <v-chip v-else :color="'info'" small disabled class="white--text">{{
                props.item.status
              }}</v-chip>
            </td>
            <td>{{ props.item.assignadminid }}</td>
            <td>
              {{
                groups[props.item.assigngroupid] ? groups[props.item.assigngroupid].groupname : '-'
              }}
            </td>
            <td>
              {{
                subgroups[props.item.assignsubgroupid]
                  ? subgroups[props.item.assignsubgroupid].subgroupname
                  : '-'
              }}
            </td>
            <td>
              <template v-if="props.item.starttime">{{
                props.item.starttime | DateFormat('DD/MM/YYYY HH:mm')
              }}</template>
            </td>
            <td>
              <template v-if="props.item.endtime">{{
                props.item.endtime | DateFormat('DD/MM/YYYY HH:mm')
              }}</template>
            </td>
            <td>
              <template v-if="props.item.starttime && props.item.endtime">{{
                durationTime(props.item.starttime, props.item.endtime)
              }}</template>
            </td>
            <td>
              <template v-if="props.item.duedate">{{
                props.item.duedate | DateFormat('DD/MM/YYYY HH:mm')
              }}</template>
            </td>
            <td style="min-width: 300px">{{ props.item.tags }}</td>
          </tr>
        </template>
      </v-data-table>
    </template>
    <div class="text-xs-center pt-2">
      <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
    </div>
  </v-container>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
const AddTicket = () => import('./AddTicket')
const EditTicket = () => import('./EditTicket')
import Multiselect from 'vue-multiselect'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
const DateRangePicker = () => import('./DateRangePicker')
import momentDurationFormatSetup from 'moment-duration-format'
import XLSX from 'xlsx'

export default {
  components: {
    AddTicket,
    EditTicket,
    Multiselect,
    datepicker,
    DateRangePicker,
  },
  data() {
    return {
      timestamp: moment().format('x'),
      showSearch: false,
      filter: {
        channel: null,
        status: null,
        group: {
          groupname: 'All',
          id: null,
        },
        contact_phone: '',
      },
      pagination: {
        sortBy: 'starttime',
        descending: true,
        rowsPerPage: 100,
      },
      priorityOptions: [
        {
          text: 'All',
          value: null,
        },
        {
          text: 'Low',
          value: 'low',
        },
        {
          text: 'Medium',
          value: 'medium',
        },
        {
          text: 'High',
          value: 'high',
        },
      ],

      headers: [
        { text: '', sortable: false },
        { text: 'Priority', value: 'priority' },
        { text: 'Name', value: 'first_name' },
        { text: 'Email', value: 'email' },
        { text: 'Phone', value: 'phoneno' },
        { text: 'Channel', value: 'channel' },
        { text: 'Subject', value: 'subject' },
        { text: 'Details', value: 'details' },
        { text: 'Status', value: 'status' },
        { text: 'Assign To', value: 'assignadminid' },
        { text: 'Group', value: 'assigngroupid' },
        { text: 'Subgroup', value: 'assignsubgroupid' },
        { text: 'Start time', value: 'starttime' },
        { text: 'End Time', value: 'endtime' },
        { text: 'Time Closed', value: 'timeclosed' },
        { text: 'Due Date', value: 'duedate' },
        { text: 'Tags', value: 'tags' },
      ],
      tickets: [],
      loading: true,
      offset: 0,
      limit: 100,
      total: 0,
      showAdd: false,
      groups: {},
      subgroups: {},
      selectedDate: {
        start: null,
        end: null,
        starttime: null,
        endtime: null,
      },
      selectedDueDate: {
        start: null,
        end: null,
        starttime: null,
        endtime: null,
      },
      items: [
        { header: 'Select an option or create one' },
        // {
        //   text: 'Foo',
        //   color: 'blue'
        // },
        // {
        //   text: 'Bar',
        //   color: 'red'
        // }
      ],
      search: null,
      tagediting: null,
      tags: [],
      showTable: true,
      filterTickets: [],
    }
  },
  created() {
    momentDurationFormatSetup(moment)
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent',
    }),
    showFilter() {
      var result = []
      if (this.filter.channel) {
        result.push(`Channel: ${this.filter.channel}`)
      }
      if (this.filter.status) {
        result.push(`Status: ${this.filter.status}`)
      }
      if (this.filter.group && this.filter.group.groupname != 'All') {
        result.push(`Group: ${this.filter.group.groupname}`)
      }
      if (this.filter.subgroup && this.filter.subgroup.subgroupname != 'All') {
        result.push(`Sub Group: ${this.filter.subgroup.subgroupname}`)
      }
      if (this.filter.admin && this.filter.admin.name != 'All') {
        result.push(`Name: ${this.filter.admin.name}`)
      }
      if (this.filter.priority && this.filter.priority.text != 'All') {
        result.push(`Priority: ${this.filter.priority.text}`)
      }
      if (this.tags.length) {
        result.push(`Tags: ${this.tags.map((el) => el.text)}`)
      }
      if (this.selectedDate.start) {
        result.push(
          `Start Date: ${moment(this.selectedDate.start).format('DD/MM/YYYY')} ${
            this.selectedDate.starttime ? this.selectedDate.starttime : ''
          }`
        )
      }
      if (this.selectedDate.end) {
        result.push(
          `End Date: ${moment(this.selectedDate.end).format('DD/MM/YYYY')} ${
            this.selectedDate.endtime ? this.selectedDate.endtime : ''
          }`
        )
      }
      if (this.selectedDueDate.start) {
        result.push(
          `Start Due Date: ${moment(this.selectedDueDate.start).format('DD/MM/YYYY')} ${
            this.selectedDueDate.starttime ? this.selectedDueDate.starttime : ''
          }`
        )
      }
      if (this.selectedDueDate.end) {
        result.push(
          `End Due Date: ${moment(this.selectedDueDate.end).format('DD/MM/YYYY')} ${
            this.selectedDueDate.endtime ? this.selectedDueDate.endtime : ''
          }`
        )
      }
      return result
    },
    pages() {
      if (this.pagination.rowsPerPage == null || this.total == null) return 0

      return Math.ceil(this.total / this.pagination.rowsPerPage)
    },
    agentGroupOptions() {
      return this.loadingAgentGroup
        ? []
        : [
            {
              groupname: 'All',
              id: null,
            },
            ...this.agentGroup,
          ]
    },
    agentSubGroupOptions() {
      if (!this.filter.group) {
        return []
      }
      var subgroup = this.agentSubGroup.filter((el) => {
        return el.admingroupid == this.filter.group.id
      })
      return this.loadingAgentSubGroup
        ? []
        : [
            {
              subgroupname: 'All',
              id: null,
            },
            ...subgroup,
          ]
    },
    agentAdminOptions() {
      if (!this.filter.group || !this.filter.subgroup) {
        return []
      }
      var agents = this.agents.filter((el) => {
        return el.subgroupname == this.filter.subgroup.subgroupname
      })
      return this.loadingAgent
        ? []
        : [
            {
              name: 'All',
              adminid: null,
            },
            ...agents,
          ]
    },
  },
  async mounted() {
    this.loading = true
    try {
      var responseGroup = await this.getAdminGroup()
      var responseSubGroup = await this.getAdminSubGroup()
      if (responseGroup.data) {
        var group = {}
        responseGroup.data.map((el) => {
          group[el.id] = el
        })
        this.groups = group
      }
      if (responseSubGroup.data) {
        var subgroup = {}
        responseSubGroup.data.map((el) => {
          subgroup[el.id] = el
        })
        this.subgroups = subgroup
      }

      var response = await this.getTickets(this.offset, this.limit)
      if (response.data) {
        this.tickets = response.data
        this.filterTickets = this.onfilterTickets()
        this.total = response.total
      }
    } catch (error) {
      console.error(error)
    }
    this.loading = false
  },
  methods: {
    clearSearch() {
      this.filter = {
        channel: null,
        status: null,
        group: {
          groupname: 'All',
          id: null,
        },
        contact_phone: '',
      }
      this.selectedDate = {
        start: null,
        end: null,
        starttime: null,
        endtime: null,
      }
      this.selectedDueDate = {
        start: null,
        end: null,
        starttime: null,
        endtime: null,
      }
      this.onSearch()
    },
    exportData() {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filename = 'ticketlist'

      var json = []

      json = this.filterTickets.map((el) => {
        return {
          Priority: el.priority ? el.priority : '-',
          Name: el.first_name ? el.first_name + ' ' + el.last_name : '-',
          'Latest Email': el.email ? el.email : '-',
          Channel: el.channel ? el.channel : '-',
          Subject: el.subject ? el.subject : '-',
          Details: el.details ? el.details : '-',
          Status: el.status ? el.status : '-',
          'Assign To': el.assignadminid ? el.assignadminid : '-',
          Group: this.groups[el.assigngroupid] ? this.groups[el.assigngroupid].groupname : '-',
          Subgroup: this.subgroups[el.assignsubgroupid]
            ? this.subgroups[el.assignsubgroupid].subgroupname
            : '-',
          'Start time': el.starttime ? moment(el.starttime).format('DD/MM/YYYY HH:mm') : '-',
          'End Time': el.endtime ? moment(el.endtime).format('DD/MM/YYYY HH:mm') : '-',
          'Time Closed':
            el.starttime && el.endtime ? this.durationTime(el.starttime, el.endtime) : '-',
          'Due Date': el.duedate ? el.duedate : '-',
          Tags: el.tags ? el.tags : '-',
        }
      })

      var dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
    },

    goToLivechat: function (user, app) {
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: user.userid,
          user: user.context == 'contactadmin' ? 'admin' : 'bot',
          app: app,
        },
      })
      window.open(routeData.href, '_blank')
    },
    durationTime(start, end) {
      var startTime = start
      var endTime = end
      var minutes = moment
        .duration(moment(endTime, 'YYYY/MM/DD HH:mm').diff(moment(startTime, 'YYYY/MM/DD HH:mm')))
        .asMinutes()
        .toFixed(2)

      return moment.duration(parseFloat(minutes), 'minutes').format('h [hrs], m [min]')
    },
    onfilterTickets() {
      if (this.$store.state.privilege) {
        switch (this.$store.state.privilege.view_ticket) {
          case 'all':
            return this.tickets
          case 'only_me':
            return this.tickets.filter((el) => {
              return el.adminid == this.$store.state.userid
            })
          case 'only_group':
            return this.tickets.filter((el) => {
              return el.assigngroupid == this.$store.state.admingroupid
            })
          case 'only_subgroup':
            return this.tickets.filter((el) => {
              return el.assignsubgroupid == this.$store.state.adminsubgroupid
            })
          default:
            return []
        }
      } else {
        return []
      }
    },
    async onSearch() {
      this.loading = true
      try {
        var filter = this.formatFilter()
        this.offset = 0
        var response = await this.getTickets(this.offset, this.limit, filter)
        if (response.data) {
          this.$nextTick(() => {
            this.tickets = response.data
            this.filterTickets = this.onfilterTickets()
          })
          this.total = response.total
        }
      } catch (error) {
        console.log(error)
      }
      this.loading = false
      this.showSearch = false
    },
    formatFilter() {
      var data = {}

      if (this.filter.channel) {
        data.channel = this.filter.channel
      }
      if (this.filter.status) {
        data.status = this.filter.status
      }
      if (this.filter.contact_phone) {
        data.contact_phone = this.filter.contact_phone
      }

      if (this.filter.group && this.filter.group.id != null) {
        data.assigngroupid = this.filter.group.id
      }

      if (this.filter.subgroup && this.filter.subgroup.id != null) {
        data.assignsubgroupid = this.filter.subgroup.id
      }
      if (this.filter.admin && this.filter.admin.adminid != null) {
        data.assignadminid = this.filter.admin.adminid
      }

      if (this.selectedDate.start) {
        data.starttime = moment(this.selectedDate.start).format('YYYY-MM-DD')
        if (this.selectedDate.starttime) {
          data.starttime += ' ' + this.selectedDate.starttime
        } else {
          data.starttime += ' ' + '00:00'
        }
      }

      if (this.selectedDate.end) {
        data.endtime = moment(this.selectedDate.end).format('YYYY-MM-DD')
        if (this.selectedDate.endtime) {
          data.endtime += ' ' + this.selectedDate.endtime
        } else {
          data.endtime += ' ' + '23:59'
        }
      }

      if (this.selectedDueDate.start) {
        data.startDueDate = moment(this.selectedDueDate.start).format('YYYY-MM-DD')
        if (this.selectedDueDate.startDueDate) {
          data.startDueDate += ' ' + this.selectedDueDate.startDueDate
        } else {
          data.startDueDate += ' ' + '00:00'
        }
      }

      if (this.selectedDueDate.end) {
        data.endDueDate = moment(this.selectedDueDate.end).format('YYYY-MM-DD')
        if (this.selectedDueDate.endDueDate) {
          data.endDueDate += ' ' + this.selectedDueDate.endDueDate
        } else {
          data.endDueDate += ' ' + '23:59'
        }
      }

      if (this.filter.priority && this.filter.priority.value != null) {
        data.priority = this.filter.priority.value
      }

      if (this.tags && this.tags.length > 0) {
        var tags = this.tags.map((el) => {
          return el.text
        })
        data.tags = tags.join(',')
      }
      return data
    },
    tagsedit(index, item) {
      if (!this.tagediting) {
        this.tagediting = item
        this.index = index
      } else {
        this.tagediting = null
        this.index = -1
      }
    },
    tagsfilter(item, queryText, itemText) {
      if (item.header) return false

      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },

    onChangeGroup(val) {
      if (val.id) {
        this.$set(this.filter, 'subgroup', { id: null, subgroupname: 'All' })
      } else {
        this.$set(this.filter, 'subgroup', null)
      }
      this.$set(this.filter, 'admin', null)
    },
    onChangeSubGroup(val) {
      this.$set(this.filter, 'admin', null)
    },
    async onAddTicket(ticket) {
      window.location.reload()

      // var response = await this.getTicketById(ticket.id)
      // if (response.data && response.data.length > 0) {
      //   this.tickets.unshift(response.data[0])
      // }
      // this.filterTickets = []
      // this.showTable = false
      // await this.$nextTick()
      // this.filterTickets = this.onfilterTickets()
      // console.log(this.filterTickets)
      // this.timestamp = moment().format('x')
      // this.showTable = true
    },
    onEditTicket(ticket) {
      // window.location.reload()
      var vm = this
      var index = this.filterTickets.findIndex((el) => el.id == ticket.id)

      this.$set(vm.filterTickets, index, { ...vm.filterTickets[index], ...ticket })
      // var response = await this.getTicketById(ticket.id)
      // var index = this.tickets.findIndex(el => {
      //   return el.id == ticket.id
      // })
      // if (index != -1 && response.data && response.data.length > 0) {
      //   this.$set(this.tickets, index, response.data[0])
      // }
      // this.filterTickets = []
      // this.showTable = false
      // await this.$nextTick()
      // this.filterTickets = this.onfilterTickets()
      // this.timestamp = moment().format('x')
      // this.showTable = true
    },
    getTicketById(id) {
      var data = {
        id: id,
        pageid: this.selectedBot.pageid,
      }
      return new Promise((resolve, reject) => {
        api.getTicketById(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    getTickets(offset, limit, filter = []) {
      var data = {
        pageid: this.selectedBot.pageid,
        limit: limit,
        offset: offset,
        ...filter,
      }
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      // console.log(sortBy, descending)

      return new Promise((resolve, reject) => {
        api.getTickets(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    getAdminGroup() {
      var data = {
        pageid: this.selectedBot.pageid,
      }
      return new Promise((resolve, reject) => {
        api.getAdminGroup(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    getAdminSubGroup() {
      var data = {
        pageid: this.selectedBot.pageid,
      }
      return new Promise((resolve, reject) => {
        api.getAdminSubGroup(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
  },
  watch: {
    pagination: {
      handler() {
        // this.getTickets()
      },
      deep: true,
    },
    tags(val, prev) {
      if (val.length === prev.length) return

      this.tags = val.map((v) => {
        if (typeof v === 'string') {
          v = {
            text: v,
          }

          this.items.push(v)
        }

        return v
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/Dashboard.vue